//file
import {atom} from "recoil";
import api from "../../../config/api.routes";
import axios from "axios";
import authHeader from "../../../services/auth-header";
import {normalizeDeletedUser} from "../charity/service/normalizeDeletedUser";

export const detailFileState = atom({
    key: 'detailFileState',
    default: '',
});

export const detailFilePreviewState = atom({
    key: 'detailFilePreviewState',
    default: '',
});

export const thumbnailFileState = atom({
    key: 'thumbnailFileState',
    default: '',
});

export const thumbnailFilePreviewState = atom({
    key: 'thumbnailFilePreviewState',
    default: '',
});

const list = (data) => {
    let url = api().apiURL + `/v2/charity/list?`;
    for (let query of Object.keys(data)) {
        if (data[query] === undefined || data[query] === '') {
            continue;
        }
        url += `${query}=${data[query]}&`;
    }
    console.log(url);
    return new Promise((resolve, reject) => {
        axios.get(url, { headers: authHeader() })
          .then(res => res.data)
          .then(res => normalizeDeletedUser(res))
          .then(res => resolve(res))
          .catch(e => reject(e));
    });
};

const update = (id, data) => {
    let url = api().apiURL + `/charity/update?charityId=${id}`;
    console.log('수정',url);
    return new Promise((resolve, reject) => {
        axios.put(url, data, { headers: authHeader() })
            .then(res => res.data)
            .then(res => resolve(res))
            .catch(e => reject(e));
    });
};

const detail = (id) => {
    let url = api().apiURL + `/v2/charity/detail?charityId=${id}`;
    console.log(url);
    return new Promise((resolve, reject) => {
        axios.get(url, { headers: authHeader() })
          .then(res => res.data)
          .then(res => normalizeDeletedUser(res))
          .then(res => resolve(res))
          .catch(e => reject(e));
    });
};

const register = (data) => {
    let url = api().apiURL + `/charity/register`;
    console.log(url,data);
    return new Promise((resolve, reject) => {
        axios.post(url, data, { headers: authHeader() })
            .then(res => res.data)
            .then(res => resolve(res))
            .catch(e => reject(e));
    });
};

const fileRegister = (id, data, diff) => {
    // diff = thumbnail 또는 image
    let url = api().apiURL + `/charity/fileUpload?charityId=${id}&diff=${diff}`;
    console.log(url);
    return new Promise((resolve, reject) => {
        axios.post(url, data, { headers: authHeader() })
          .then(res => res.data)
          .then(res => resolve(res))
          .catch(e => reject(e));
    });
};

const remove = (id) => {
    let url = api().apiURL + `/charity/delete?charityId=${id}`;
    console.log(url);
    return new Promise((resolve, reject) => {
        axios.delete(url, { headers: authHeader() })
            .then(res => res.data)
            .then(res => resolve(res))
            .catch(e => reject(e));
    });
};

// /charityHistory/detail

const charityHistoryDetail = (data) => {
    let url = api().apiURL + `/charityHistory/detail?`;
    for (let query of Object.keys(data)) {
        if (data[query] === undefined || data[query] === '') {
            continue;
        }
        url += `${query}=${data[query]}&`;
    }
    console.log(url);
    return new Promise((resolve, reject) => {
        axios.get(url, { headers: authHeader() })
          .then(res => res.data)
          .then(res => resolve(res))
          .catch(e => reject(e));
    });
};

const charityHistoryDetailDown = (data) => {
    let url = api().apiURL + `/charityHistory/detail?`;
    for (let query of Object.keys(data)) {
        if (data[query] === undefined || data[query] === '') {
            continue;
        }
        url += `${query}=${data[query]}&`;
    }
    console.log(url);
    return new Promise((resolve, reject) => {
        axios.get(url, { headers: authHeader(), responseType: 'arraybuffer' })
          .then(res => resolve(res))
          .catch(e => reject(e));
    });
};

const donationService = {
    list,
    update,
    detail,
    register,
    fileRegister,
    remove,
    charityHistoryDetail,
    charityHistoryDetailDown
}

export default donationService;
